import Link from "next/link";
import type { ComponentProps } from "react";
import React from "react";
import { DealConstructionScheduleClientCard } from "~/components/common/deals/show/construction_card/DealConstructionScheduleClientCard";
import { DealCard } from "~/components/common/deals/show/deal_card/DealCard";
import { DealVendorNoteCard } from "~/components/common/deals/show/deal_card/DealVendorNoteCard";
import { DealInspectionCandidateDateCard } from "~/components/common/deals/show/inspection_candidate_date_card/DealInspectionCandidateDateCard";
import { DealRepairCard } from "~/components/common/deals/show/repair_card/DealRepairCard";
import { DealOriginVendorClientCard } from "~/components/common/deals/show/vendor_card/DealOriginVendorClientCard";
import { DealVisitDateClientCard } from "~/components/common/deals/show/visit_date_card/DealVisitDateClientCard";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientDealLayout } from "~/components/common/layouts/deals/ClientDealLayout";
import Loader from "~/components/common/parts/loading/Loading";
import { useDeals } from "~/hooks/useDeals";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import useItandiAccount from "~/hooks/useItandiAccount";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import { PATH as DEALS_PATH } from "~/pages/deals";
import { PATH as DEAL_PATH } from "~/pages/deals/[id]";

export const Page: React.FC = () => {
	const { data: account } = useItandiAccount().currentAccount();
	const id = useIdQueryHandler();
	const { data: deal, mutate: mutateDeal, isLoading } = useDeals().show(id);
	const handleMutate = React.useCallback(async () => {
		await mutateDeal?.();
	}, [mutateDeal]);
	if (isLoading || deal === null || account === null) {
		return <Loader isLoading />;
	}
	const items = [
		{ as: Link, href: DEALS_PATH, label: "案件一覧" },
		{ as: Link, href: DEAL_PATH(deal.id), label: "案件詳細" },
		{ label: "案件内容" }
	] as const satisfies ComponentProps<typeof ClientDealLayout>["items"];
	return (
		<ItandiAccountContext.Provider value={account}>
			<DefaultV2>
				<ClientDealLayout deal={deal} items={items} noBackground>
					<DealOriginVendorClientCard />
					<DealVendorNoteCard deal={deal} />
					<DealCard deal={deal} />
					<DealRepairCard
						companyType="client"
						deal={deal}
						handleMutate={handleMutate}
					/>
					<DealVisitDateClientCard />
					<DealInspectionCandidateDateCard
						deal={deal}
						handleMutate={handleMutate}
					/>
					<DealConstructionScheduleClientCard />
				</ClientDealLayout>
			</DefaultV2>
		</ItandiAccountContext.Provider>
	);
};
